export default __webpack_public_path__ + "static/media/electrician3.f0133da7.png";